import { Button } from '@hungryroot/ramen';
import { buttonClickedEvent } from '@hungryroot/segment';
import {
  type AstroNavLinks,
  type SpaNavLinks,
} from '../CatalogNavigation/NavLinks';
import styles from './CatalogDesktopNavigationLinks.module.css';

type Props = {
  navLinks: (AstroNavLinks | SpaNavLinks)[];
};

export function CatalogDesktopNavigationLinks({ navLinks }: Props) {
  return (
    <div className={styles['nav-links-catalog']}>
      {navLinks.map((link) => {
        const { text } = link;
        const buttonName = `${text.toLowerCase()}_header`;

        if ('href' in link) {
          return (
            <Button
              key={link.href}
              prominence="tertiary"
              style="default"
              size="medium"
              buttonType="link"
              to={link.href}
              textPrimary={text}
              onClick={() => {
                buttonClickedEvent({
                  button_name: buttonName,
                  order_id: null,
                  page_position: '',
                });
              }}
            />
          );
        }

        return (
          <Button
            key={text}
            prominence="tertiary"
            style="muted"
            size="medium"
            buttonType="button"
            onClick={() => {
              link.onClick();
              buttonClickedEvent({
                button_name: buttonName,
                order_id: null,
                page_position: '',
              });
            }}
            textPrimary={text}
          />
        );
      })}
    </div>
  );
}
